/* 布局 */
//前台
import Layout from "@views/layout";

const expertmvpstationedromotionaccountRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "expertmvpstationedromotionaccount",
            name: "EXPERTMVPSTATIONEDROMOTIONACCOUNT",
            meta: {
                title: "MVP专家宣传账号",
                sort: 1,
            },
            component: () => import("@views/business/expertmvpstationedromotionaccount/index.vue"),
            redirect: {
                name: "EXPERTMVPSTATIONEDROMOTIONACCOUNT_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EXPERTMVPSTATIONEDROMOTIONACCOUNT_LIST",
                    meta: {
                        title: "MVP专家宣传账号",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/expertstationedromotionaccount/index.vue"),
                },
                {
                    path: "add",
                    name: "EXPERTMVPSTATIONEDROMOTIONACCOUNT_ADD",
                    meta: {
                        title: "新增mvp专家宣传账号",
                        parentPath: '/business/expertmvpstationedromotionaccount/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertmvpstationedromotionaccount/form.vue"),
                },
                {
                    path: "edit",
                    name: "EXPERTMVPSTATIONEDROMOTIONACCOUNT_EDIT",
                    meta: {
                        title: "编辑mvp专家宣传账号",
                        parentPath: '/business/expertmvpstationedromotionaccount/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertmvpstationedromotionaccount/form.vue"),
                },
            ],
        },


    ],
};

export default expertmvpstationedromotionaccountRouter;
